import { useState, useEffect } from "react";
import useDynamicFormFields from "./UseDynamicInput";
import checkboxesFormat from "../Data/TriathlonSizeData";

const ids = [
  { key: "0" },
  { key: "1" },
  { key: "2" },
  { key: "3" },
  { key: "4" },
  { key: "5" },
  { key: "6" },
];

// const defaultRace = [
//   {
//     event_id: "",
//     date: "",
//     name_race: "",
//     Elevation_bike: null,
//     Elevation_run: null,
//     Swimenv: "0",
//     bibs: 0,
//     crosstri: "0",
//     details: "",
//     price_triathlon: "",
//     relay: "0",
//     type_triathlon: "",
//   },
// ];

export const DynamicInput = (props) => {
  const { handleChangeArray } = props;
  const { formData, generalDate, eventName } = props;

  const racePrefill = formData.races ? formData.races : [];

  const { fields, handleCheckboxChange } = useDynamicFormFields(racePrefill);
  const [eventDetail, setEventDetail] = useState(
    formData.races
      ? ids.map((item, key) =>
          racePrefill[key] ? { ...item, ...racePrefill[key] } : item
        )
      : ids
  ); // id list for 7 lines = 7 race types // formData.races ? formData.races :ids

  // pas de prise en compte des modifications : ajout d'une ligne race (objet) ou modification d'un champ de l'objet
  // lorsque eventDetail est initialisé avec racePrefill, il ne dispose plus des différentes Key
  // CELA MARCHE AVEC ids mais pas racePrefill => modifier racePrefill afin qu'il intègre les key

  const handleEvent = (e) => {
    setEventDetail((item) =>
      item.map((obj) =>
        obj.key === e.target.name.split("-")[1]
          ? { ...obj, [e.target.name.split("-")[0]]: e.target.value }
          : obj
      )
    );
  };

  useEffect(() => {
    let arrayRaces = eventDetail.slice(0, fields.length);
    let arrayWithType = arrayRaces.map((item, index) => ({
      ...item,
      type_triathlon: fields[index],
      //date: racePrefill[index] ? racePrefill[index].date : generalDate,
      name_race: eventName || null,
    }));

    handleChangeArray(arrayWithType);
  }, [eventDetail, fields]);

  return (
    <div className="row">
      <div className="col-md-12 font-weight-bold my-2">
        Liste des courses (sélectionner les formats)
      </div>
      <div className="col-md-12">
        {checkboxesFormat.map((item, id) => (
          <label key={item.key} className="mr-2">
            {item.value}
            <input
              type="checkbox"
              className="ml-2"
              name={id}
              value={item.value}
              // checked={checkedItems[item.name]}

              onChange={handleCheckboxChange}
            />
          </label>
        ))}
      </div>
      {fields.map((field, key) => (
        <div className="col-md-12 mb-2" key={key}>
          <input
            type="text"
            key={`type_triathlon-${key}`}
            name={`type_triathlon-${key}`}
            className="col-md-1 bg-primary border-0 mr-2 mb-1"
            value={field.type_triathlon || field}
            onChange={(e) => handleEvent(e)}
            //defaultValue={field.type_triathlon}
          />

          <input
            type="text"
            key={`date-${key}`}
            name={`date-${key}`}
            placeholder={new Date()}
            //defaultValue={new Date().toISOString()} //formData.date.toISOString()
            className="col-md-3 mr-2 mb-1"
            value={eventDetail.date}
            onChange={(e) => handleEvent(e)}
            defaultValue={
              eventDetail.some((o) => o.type_triathlon === field)
                ? eventDetail.find((o) => o.type_triathlon === field).date
                : generalDate
            }
          />

          <input
            type="text"
            key={`price_triathlon-${key}`}
            name={`price_triathlon-${key}`}
            placeholder={`Prix`}
            className="col-md-1 mr-2 mb-1"
            value={eventDetail.price_triathlon}
            onChange={(e) => handleEvent(e)}
            defaultValue={
              eventDetail.some((o) => o.type_triathlon === field)
                ? eventDetail.find((o) => o.type_triathlon === field)
                    .price_triathlon
                : ""
            }
          />
          <input
            type="text"
            key={`bibs-${key}`}
            name={`bibs-${key}`}
            placeholder={`Dossard`}
            className="col-md-1 mr-2 mb-1"
            value={eventDetail.bibs}
            onChange={(e) => handleEvent(e)}
            defaultValue={
              eventDetail.some((o) => o.type_triathlon === field)
                ? eventDetail.find((o) => o.type_triathlon === field).bibs
                : ""
            }
          />
          <input
            type="text"
            key={`Elevation_bike-${key}`}
            name={`Elevation_bike-${key}`}
            placeholder={`d+ Bike`}
            className="col-md-1 mr-2 mb-1"
            value={eventDetail.Elevation_bike}
            onChange={(e) => handleEvent(e)}
            defaultValue={
              eventDetail.some((o) => o.type_triathlon === field)
                ? eventDetail.find((o) => o.type_triathlon === field)
                    .Elevation_bike
                : ""
            }
          />
          <input
            type="text"
            key={`Elevation_run-${key}`}
            name={`Elevation_run-${key}`}
            placeholder={`d+ Run`}
            className="col-md-1 mr-2 mb-1"
            value={eventDetail.Elevation_run}
            onChange={(e) => handleEvent(e)}
            defaultValue={
              eventDetail.some((o) => o.type_triathlon === field)
                ? eventDetail.find((o) => o.type_triathlon === field)
                    .Elevation_run
                : ""
            }
          />
          <select
            className="mr-2 my-2 form-select form-select-sm"
            aria-label="Natation"
            name={`Swimenv-${key}`}
            value={eventDetail.Swimenv}
            onChange={(e) => handleEvent(e)}
            defaultValue={
              eventDetail.some((o) => o.type_triathlon === field)
                ? eventDetail.find((o) => o.type_triathlon === field).Swimenv
                : ""
            }
          >
            <option value="" disabled defaultValue="">
              Natation en...
            </option>
            <option value="Piscine">Piscine</option>
            <option value="Lac">Lac</option>
            <option value="Mer">Mer</option>
            <option value="Rivière">Rivière</option>
            <option value="Plan d'eau">Plan d'eau</option>
          </select>
          <select
            className="mx-2 form-select"
            aria-label="Cross triathlon"
            name={`crosstri-${key}`}
            value={eventDetail.crosstri}
            onChange={(e) => handleEvent(e)}
            defaultValue={
              eventDetail.some((o) => o.type_triathlon === field)
                ? eventDetail.find((o) => o.type_triathlon === field).crosstri
                : "0"
            }
          >
            <option value="" disabled selected>
              Cross triathlon
            </option>
            <option value="1">Oui</option>
            <option value="0">Non</option>
          </select>
          <select
            className="mx-2 form-select"
            aria-label="Relais"
            name={`relay-${key}`}
            value={eventDetail.relay}
            onChange={(e) => handleEvent(e)}
            defaultValue={
              eventDetail.some((o) => o.type_triathlon === field)
                ? eventDetail.find((o) => o.type_triathlon === field).relay
                : "0"
            }
          >
            <option value="" disabled selected>
              Relais
            </option>
            <option value="1">Oui</option>
            <option value="0">Non</option>
          </select>
          <input
            type="text"
            key={`details-${key}`}
            name={`details-${key}`}
            value={eventDetail.details}
            placeholder={`Description`}
            className="col-md-8 mr-2 mb-1"
            onChange={(e) => handleEvent(e)}
            defaultValue={
              eventDetail.some((o) => o.type_triathlon === field)
                ? eventDetail.find((o) => o.type_triathlon === field).details
                : ""
            }
          />
        </div>
      ))}
    </div>
  );
};
